module.exports = __webpack_public_path__ + "static/zircon-heart-double-length-chain-necklace-91fec1dfa7a9652673b87fc9f9132c08.jpg";